import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Table from '../../components/Common/Table';
import api from '../../utils/api';
import { showDeleteConfirm, showSuccess, showError } from '../../utils/swal';

const RentalList = () => {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRentals();
  }, []);

  const fetchRentals = async () => {
    try {
      const response = await api.get('/rentals');
      setRentals(response.data.data || response.data);
      setLoading(false);
    } catch (error) {
      console.error('Kiralamalar yüklenemedi:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const customerName = `${row.customer?.name} ${row.customer?.surname}`;
    const result = await showDeleteConfirm(`${customerName} müşterisine ait kiralama`);

    if (!result.isConfirmed) {
      return;
    }

    try {
      await api.delete(`/rentals/${row.id}`);
      showSuccess('Kiralama başarıyla silindi');
      fetchRentals();
    } catch (error) {
      console.error('Kiralama silinemedi:', error);
      showError('Kiralama silinirken bir hata oluştu');
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      active: { label: 'Aktif', color: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800' },
      expired: { label: 'Süresi Dolmuş', color: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-800' },
      terminated: { label: 'Feshedilmiş', color: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800' },
    };
    const info = statusMap[status] || { label: status || '-', color: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600' };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium border ${info.color}`}>
        {info.label}
      </span>
    );
  };

  const columns = [
    {
      header: 'İşlemi Yapan Görevli',
      accessor: 'user',
      render: (row) => row.user?.name || '-'
    },
    {
      header: 'Kiracı',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.customer?.id) navigate(`/customers/${row.customer.id}`);
          }}
        >
          {`${row.customer?.name || ''} ${row.customer?.surname || ''}`.trim() || '-'}
        </span>
      )
    },
    {
      header: 'Kiralanan Gayrimenkul',
      accessor: 'portfolio',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.portfolio?.id) navigate(`/portfolios/${row.portfolio.id}`);
          }}
        >
          {row.portfolio?.title || '-'}
        </span>
      )
    },
    {
      header: 'Kira Bedeli',
      accessor: 'rental_price',
      render: (row) => row.rental_price ? `${parseFloat(row.rental_price).toLocaleString('tr-TR')} ₺` : '-'
    },
    {
      header: 'Komisyon',
      accessor: 'commission_amount',
      render: (row) => row.commission_amount ? `${parseFloat(row.commission_amount).toLocaleString('tr-TR')} ₺` : '-'
    },
    {
      header: 'Başlangıç',
      accessor: 'start_date',
      render: (row) => row.start_date ? new Date(row.start_date).toLocaleDateString('tr-TR') : '-'
    },
    {
      header: 'Bitiş',
      accessor: 'end_date',
      render: (row) => row.end_date ? new Date(row.end_date).toLocaleDateString('tr-TR') : '-'
    },
    {
      header: 'Durum',
      accessor: 'status',
      render: (row) => getStatusBadge(row.status)
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Yükleniyor...</div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">Kiralamalar</h1>

      <Card noPadding>
        <Table
          columns={columns}
          data={rentals}
          onView={(row) => navigate(`/portfolios/${row.portfolio?.id}`)}
          onDelete={handleDelete}
        />
      </Card>
    </div>
  );
};

export default RentalList;
